<div>
  <div class="measure-type-toggle">
    <mat-button-toggle-group
      [value]="activeMeasureType"
      (change)="onMeasureTypeChange($event.value)"
    >
      <mat-button-toggle [value]="measureType.Length">
        {{ 'igo.geo.measure.' + measureType.Length | translate }}
      </mat-button-toggle>
      <mat-button-toggle [value]="measureType.Area">
        {{ 'igo.geo.measure.' + measureType.Area | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="measure-options">
    <mat-slide-toggle
      [disabled]="drawControlIsDisabled"
      [checked]="drawControlIsActive"
      [labelPosition]="'before'"
      (change)="onToggleDrawControl($event.checked)"
    >
      {{ 'igo.geo.measure.toggleActive' | translate }}
    </mat-slide-toggle>

    @if (hasLine$ | async) {
      <mat-divider />
    }

    @if (hasLine$ | async) {
      <mat-slide-toggle
        [checked]="displayLines"
        [labelPosition]="'before'"
        (change)="onToggleDisplayLines($event.checked)"
      >
        {{ 'igo.geo.measure.toggleDisplayLines' | translate }}
      </mat-slide-toggle>
    }

    @if ((hasLine$ | async) || (hasArea$ | async)) {
      <mat-divider />
    }

    @if (hasArea$ | async) {
      <mat-slide-toggle
        [checked]="displayDistance"
        [labelPosition]="'before'"
        (change)="onToggleDisplayDistance($event.checked)"
      >
        {{ 'igo.geo.measure.toggleDisplayDistance' | translate }}
      </mat-slide-toggle>
    }

    @if (hasArea$ | async) {
      <mat-slide-toggle
        [checked]="displayAreas"
        [labelPosition]="'before'"
        (change)="onToggleDisplayAreas($event.checked)"
      >
        {{ 'igo.geo.measure.toggleDisplayAreas' | translate }}
      </mat-slide-toggle>
    }

    @if (hasArea$ | async) {
      <mat-divider />
    }

    <mat-slide-toggle
      [checked]="measureUnitsAuto"
      [labelPosition]="'before'"
      (change)="onToggleMeasureUnitsAuto($event.checked)"
    >
      {{ 'igo.geo.measure.toggleAutoUnits' | translate }}
    </mat-slide-toggle>
  </div>

  @if (measure$ | async; as measure) {
    @if (
      activeMeasureType === measureType.Length ||
      activeMeasureType === measureType.Area
    ) {
      <igo-measurer-item
        [measureType]="measureType.Length"
        [measureUnit]="activeLengthUnit"
        [measure]="measure.length"
        [auto]="measureUnitsAuto"
        [placeholder]="
          (activeMeasureType === measureType.Area
            ? 'igo.geo.measure.perimeter'
            : 'igo.geo.measure.length'
          ) | translate
        "
        (measureUnitChange)="onLengthUnitChange($any($event))"
      />
    }
    @if (activeMeasureType === measureType.Area) {
      <igo-measurer-item
        [measureType]="measureType.Area"
        [measureUnit]="activeAreaUnit"
        [measure]="measure.area"
        [auto]="measureUnitsAuto"
        [placeholder]="'igo.geo.measure.area' | translate"
        (measureUnitChange)="onAreaUnitChange($any($event))"
      />
    }
  }

  @if ((hasLine$ | async) || (hasArea$ | async)) {
    <mat-divider />
  }

  <div class="measure-store-buttons">
    @if ((hasLine$ | async) || (hasArea$ | async)) {
      <button
        mat-icon-button
        [matTooltip]="'igo.geo.measure.actionbar.calculate.tooltip' | translate"
        [disabled]="(selectedFeatures$ | async).length === 0"
        color="accent"
        (click)="onCalculateClick()"
      >
        <mat-icon>calculate</mat-icon>
      </button>
    }

    @if ((hasLine$ | async) || (hasArea$ | async)) {
      <button
        mat-icon-button
        [matTooltip]="'igo.geo.measure.actionbar.delete.tooltip' | translate"
        [disabled]="(selectedFeatures$ | async).length === 0"
        color="warn"
        (click)="onDeleteClick()"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>

  <igo-entity-table
    #table
    class="table-compact"
    [store]="store()"
    [template]="tableTemplate"
  />
</div>
